import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const HEADS = [
  "Bed Roll",
  "Coach Cleanliness",
  "Coach Maintenance",
  "Water Availability",
];

export const HEAD_COLORS = {
  "Bed Roll": { bg: "#EFF6FF", text: "#1E40AF", stroke: "#2563EB" },
  "Coach Cleanliness": { bg: "#FEF3C7", text: "#92400E", stroke: "#D97706" },
  "Coach Maintenance": { bg: "#F3E8FF", text: "#6B21A8", stroke: "#9333EA" },
  "Water Availability": { bg: "#E0F2FE", text: "#075985", stroke: "#0284C7" },
};
